import { render } from "./BaseLoader.vue?vue&type=template&id=9e0efd64&scoped=true&ts=true"
import script from "./BaseLoader.vue?vue&type=script&lang=ts"
export * from "./BaseLoader.vue?vue&type=script&lang=ts"

import "./BaseLoader.vue?vue&type=style&index=0&id=9e0efd64&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e0efd64"]])

export default __exports__